import { IResponse } from "models";

export enum ActionType {
  DEPARTMENT_LIST_BUSINESS = "action/DEPARTMENT_LIST_BUSINESS",
  DEPARTMENT_LIST_BUSINESS_SUCCESS = "action/DEPARTMENT_LIST_BUSINESS_SUCCESS",
  DEPARTMENT_LIST_BUSINESS_ERROR = "action/DEPARTMENT_LIST_BUSINESS_ERROR",
  DEPARTMENT_LIST_BUSINESS_RESET_DATA = "action/DEPARTMENT_LIST_BUSINESS_RESET_DATA",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface IDepartmentBusiness {
  id: number;
  name: string;
}

export interface DepartmentListBusinessResponse extends IResponse {
  result: IDepartmentBusiness[];
}
